module.exports = __webpack_public_path__ + "img/edit.2f402cd5.svg";